export const MIN_DAYS_FOR_FILE_ACCESS = 4;
export const INITIAL_FILE_ACCESS_DAYS = 14;
export const INITIAL_EXTEND_ACCESS_DAYS = 5;

export const MIN_SESSION_MINUTES = 10;
export const MAX_SESSION_MINUTES = 1440;

export const SESSION_TIMEOUT_KEY = 'sessionTimeout';

export const SESSION_TIMEOUT_PRESETS = [
  { label: 'sessionTimeout30Min', value: 30 },
  { label: 'sessionTimeout1h', value: 60 },
  { label: 'sessionTimeout2h', value: 120 },
  { label: 'sessionTimeout6h', value: 360 },
  { label: 'sessionTimeout12h', value: 720 },
  { label: 'sessionTimeout24h', value: MAX_SESSION_MINUTES },
];
